import { Box } from '@mui/material';
import { Loaders } from 'components/Loader';
import { Table } from 'components/Table';
import { useMemo, useState } from 'react';
import { CustomCheckBox } from './CustomCheckBox';
import { CustomActionsBox } from './CustomActionsBox';
import { CustomActionsBoxCollections } from './CustomActionsBoxCollections';
import { ExpandedVideos } from '../../../pages/VideosHome/Expanded';
import { ExpandedSeries } from '../../../pages/SeriesHome/Expanded';
import { ExpandedCollectionsNew } from '../../../pages/CollectionsHomeNew/Expanded';
import { Icon } from 'components/Icon';
import '../../../pages/videos/Videos.css';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useNotification } from 'hooks/useNotification';

export const DataView = ({
  data,
  columns,
  selected = [],
  selectedVersion = [],
  onChangeSelected = () => {},
  isLoading,
  showHeader = true,
  showEmpty = true,
  limitExceeded,
  type,
}) => {
  const [trigger, setTrigger] = useState(false);
  const { setNotify } = useNotification();
  const [selectedRows, setSelectedRows] = useState(() =>
    selected.reduce(
      (acc, current) => ({
        ...acc,
        [current.id]: true,
      }),
      {}
    )
  );
  const toggleRow = rowId => {
    setExpandedRows(prevExpandedRows => ({
      ...prevExpandedRows,
      [rowId]: !prevExpandedRows[rowId],
    }));
    toggleLoading(rowId, true);
  };

  const toggleLoading = (rowId, value) => {
    setLoadVersion(prevLoadVersion => ({
      ...prevLoadVersion,
      [rowId]: value => !trigger,
    }));
  };

  const [loadVersion, setLoadVersion] = useState({});
  const [expandedRows, setExpandedRows] = useState({});

  const isEmpty = useMemo(() => !isLoading && !data?.length, [isLoading, data]);

  if (isLoading) {
    return (
      <Table.TableBody>
        <tr>
          <td>
            <Box
              sx={{
                minHeight: '443px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <Loaders.TableInfo />
            </Box>
          </td>
        </tr>
      </Table.TableBody>
    );
  }

  if (showEmpty && isEmpty) {
    return (
      <Table.TableBody>
        <tr>
          <td>
            <div className="user_datatable_loading">
              <div>
                <Icon name="emptyBox" />
              </div>
              <p className="datatable_nodata_text">
                Não encontramos registros para os dados informados.
              </p>
            </div>
          </td>
        </tr>
      </Table.TableBody>
    );
  }

  return (
    <>
      {showHeader && <Table.Head columns={columns} />}
      <Table.TableBody>
        {data.map((row, index) => {
          return (
            <>
              <Table.TableRow hover tabIndex={-1} key={row.id}>
                {columns.map(column => {
                  const value = row[column.field];
                  return (
                    <Table.TableCell
                      key={column.field}
                      align={column.align || 'center'}
                      sx={{
                        minWidth: column.minWidth,
                        height: column.height || '49px',
                        maxWidth: column.maxWidth,
                        width: column.width,
                        padding: column.type === 'expanded' ? '0px' : '8px',
                      }}>
                      {(() => {
                        switch (column.type) {
                          case 'select':
                            return (
                              <CustomCheckBox
                                limitExceeded={limitExceeded}
                                row={row}
                                selectedRows={selectedRows}
                                onChange={rowId => {
                                  setSelectedRows(previousData => {
                                    const newData = {
                                      ...previousData,
                                      [rowId]: !previousData?.[rowId],
                                    };

                                    onChangeSelected(newData);

                                    return newData;
                                  });
                                }}
                              />
                            );
                          case 'expanded':
                            return (
                              <Box
                                sx={{
                                  backgroundColor: expandedRows[row.id]
                                    ? '#cacaca'
                                    : undefined,
                                }}
                                className="button_version_body"
                                onClick={() => {
                                  toggleRow(row.id);
                                  setTrigger(row.id);
                                }}>
                                <>
                                  {expandedRows[row.id] ? (
                                    <KeyboardArrowDownIcon />
                                  ) : (
                                    <KeyboardArrowRightIcon />
                                  )}
                                </>
                              </Box>
                            );
                          case 'actions-videos':
                            return (
                              <CustomActionsBox
                                data={data[index]}
                                setNotify={setNotify}
                              />
                            );
                          case 'actions-series':
                          case 'actions-collections':
                          case 'actions-collections-new':
                            return (
                              <CustomActionsBoxCollections
                                data={data[index]}
                                setNotify={setNotify}
                              />
                            );

                          default:
                            return column.render
                              ? column.render(value, row)
                              : value;
                        }
                      })()}
                    </Table.TableCell>
                  );
                })}
              </Table.TableRow>
              {type === 'actions-videos' ? (
                <>
                  <ExpandedVideos
                    id={row.id}
                    version={row.version}
                    columns={columns}
                    trigger={trigger}
                    status={loadVersion[row.id]}
                    expanded={expandedRows[row.id]}
                    setNotify={setNotify}
                    // ref={ref}
                  />
                </>
              ) : type === 'actions-collections-new' ? (
                <>
                  <ExpandedCollectionsNew
                    id={row.id}
                    version={row.version}
                    columns={columns}
                    trigger={trigger}
                    status={loadVersion[row.id]}
                    expanded={expandedRows[row.id]}
                    setNotify={setNotify}
                  />
                </>
              ) : (
                <>
                  <ExpandedSeries
                    id={row.id}
                    version={row.version}
                    columns={columns}
                    trigger={trigger}
                    status={loadVersion[row.id]}
                    expanded={expandedRows[row.id]}
                    setNotify={setNotify}
                    // ref={ref}
                  />
                </>
              )}
            </>
          );
        })}
      </Table.TableBody>
    </>
  );
};
